import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import axios from ".././axios-interceptor";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import {
  base_url,
  LOAN_CURRENCY_TYPE_USD,
  LOAN_CURRENCY_TYPE_BHD,
  RATING_A,
  RATING_B,
  RATING_C,
  RATING_D,
  STATUS_NEW,
  STATUS_IN_PROGRESS,
  STATUS_PROCESSED,
  STATUS_REJECTED,
  STATUS_APPROVED,
  SERVICE_REQUEST_NEW_LOAN,
  SERVICE_REQUEST_EXTEND_TENURE,
  SERVICE_REQUEST_PRE_CLOSURE,
  SERVICE_REQUEST_PARTIAL_PRE_PAYMENT,
  STATUS_CLOSED,
  LOAN_REPAYMENT_BY_BUSINESS
} from "../utilities";
import { Table } from "react-bootstrap";
import moment from "moment";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
const getAboutBusinessHtml = (opportunity) => {
  return opportunity?.about_business_html || "";
};

function InvestorCards(props) {
  const navigate = useNavigate();
  useEffect(() => {
  if (!Cookies.get("User_Accesstoken_Investor")) {
    navigate('/');
  }
 }, []);

  let ltwo = props.loading;
  // let loading = props.setloading;
  const [loading, setLoading] = useState(true);

  const [investorData, setInvestorData] = useState([]);
  useEffect(() => {
    axios
      .post(base_url + "investor-master/get_investor_master_user", {
        user_id: Cookies.get("investor_user_id"),
      })
      .then((res) => {
  
        axios
          .post(base_url + "investor-requests/get_investor_opportunities", {
            investor_id: res?.data?.data?.investor_id,
          })
          .then((res) => {
            let filtered_data = [];
            res?.data?.data?.forEach((elem) => {
              if (elem.is_visited === 0) {
                filtered_data.push(elem);
              }
            });
            setLoading(false)
            setInvestorData(filtered_data);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        if (err.response.statusText == "Unauthorized") {
          toast.error("Your session has expired. Please login again", {
            toastId: 7,
          });
          Cookies.remove("User_Accesstoken_Investor");
          Cookies.remove("User_Refreshtoken_Investor");
          navigate("/");
        }
      });
  }, []);
  const [allBusinesses, setAllBusinesses] = useState("d-block");
  const [indivBusiness, setIndivBusiness] = useState("d-none");
  const [indivLoanID, setIndivLoanID] = useState([]);
  const handleIndivBusinessDisplay = (loan_id) => {
    setAllBusinesses("d-none");
    setIndivBusiness("d-block");
    setIndivLoanID(loan_id);
  };
  const handleAllBusinessDisplay = () => {
    setIndivBusiness("d-none");
    setAllBusinesses("d-block");
  };
  return (
    <div>
      <div className={allBusinesses}>
       {ltwo || loading ?  <div className="d-flex mt-5">
       <div className="col">
         <Skeleton height={300} width={250} count={1}/>
         <Skeleton height={300} width={250} count={1}/>
         </div>
         <div className="col">
         <Skeleton height={300} width={250} count={1}/>
         <Skeleton height={300} width={250} count={1}/>

         </div>
         <div className="col">
         <Skeleton height={300} width={250} count={1}/>
         <Skeleton height={300} width={250} count={1}/>
         </div>
       </div>
       
                           : investorData.length !==0 ? <h1 className="m-3">Investment Opportunities</h1>
       : <div className="no_opp">
         <h1 >No Investment Opportunities</h1>
       </div>}
        <Row xs={1} md={3} xxl={3} xxxl={4} className={`'g-lg-2 g-md-3 g-xxl-3 p-xxl-3' `}>
          {investorData.map((data, index) => {
            let rating = data.rating;
            return (
              <Col key={index}>
                <Card  className="m-lg-2 m-xxl-3 card_styl">
                  <h4
                    className={
                      rating === RATING_A
                        ? "rate_A"
                        : rating === RATING_B
                        ? "rate_B"
                        : rating === RATING_C
                        ? "rate_C"
                        : "rate_D"
                    }
                  >
                    {rating === RATING_A
                      ? "A"
                      : rating === RATING_B
                      ? "B"
                      : rating === RATING_C
                      ? "C"
                      : rating === RATING_D
                      ? "D"
                      : ""}
                  </h4>
                  {data.is_visited === 1 ? (
                    <i className="fa-regular fa-square-check card_checked" />
                  ) : (
                    ""
                  )}
                  <Card.Img variant="top" src={data.business_image_url} style={{minHeight: '150px'}} />
                  <Card.Body>
                    <Card.Title className="inv_card_title_cls">
                      <div>{data.business_type}</div>
                      <div>
                        <img
                          src="./images/icons/rightarrow.svg"
                          alt=""
                          onClick={() =>
                            handleIndivBusinessDisplay(data.loan_id)
                          }
                        />{" "}
                      </div>
                    </Card.Title>
                    <Card.Text className="pb-2 inv_card_txt">
                      {data.notes}
                    </Card.Text>
                    <div className="d-flex justify-content-between mb-3 mt-2">
                      <div className="blue_tab ">
                        <p>Loan amount</p>
                        <p>
                          {data.admin_request_loan_currency ===
                          LOAN_CURRENCY_TYPE_USD
                            ? "$ " + Number(data.admin_request_loan_amount).toLocaleString()
                            : "BHD " + Number(data.admin_request_loan_amount).toLocaleString()}
                        </p>
                      </div>
                      <div className=" ">
                        <div className="sesame_tab">
                          <p>Tenure & Profit Rate</p>
                          <p>
                            {data.admin_request_loan_tenure != undefined
                              ? data.admin_request_loan_tenure === 1
                                ? data.admin_request_loan_tenure + " Month"
                                : data.admin_request_loan_tenure + " Months"
                              : ""}{" "}
                            - {data.investor_roi}% per month
                          </p>
                        </div>
                      </div>
                    </div>

                    <footer className="d-flex justify-content-between px-1 align-items-center">
                      <div className=" justify-content-between">
                        <p>Total Expected Return</p>
                        <b>
                          {data.admin_request_loan_currency ===
                          LOAN_CURRENCY_TYPE_USD
                            ? "$ " + Number(data.expected_return).toLocaleString()
                            : "BHD " + Number(data.expected_return).toLocaleString()}
                        </b>
                      </div>
                      <div
                        className="text-decoration-underline Cpointer blue-text"
                        onClick={() => handleIndivBusinessDisplay(data.loan_id)}
                      >
                        {data.is_visited === 1
                          ? "Already Interested"
                          : "I'm Interested"}
                      </div>
                    </footer>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
      <div className={indivBusiness}>
        <SingleCompanyDetails
          habd={handleAllBusinessDisplay}
          investorData={investorData}
          indivLoanID={indivLoanID}
          loading={loading}
        />
      </div>
    </div>
  );
}

export default InvestorCards;

const SingleCompanyDetails = (props) => {
  let investorData = props.investorData;
  let indivLoanID = props.indivLoanID;
let loading = props.loading;
  const [businessData, setBusinessData] = useState([]);
  const [loanhistory, setLoanHistory] = useState([]);
  const [investorMaster, setInvestorMaster] = useState([]);


  let indiviBussData = [];
  useEffect(() => {
    axios
      .post(base_url + "investor-master/get_investor_master_user", {
        user_id: Cookies.get("investor_user_id"),
      })
      .then((res) => {
 
        setInvestorMaster(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  investorData.filter((item) => {
    if (item.loan_id === indivLoanID) {
      if (item.status == STATUS_NEW) {
        item.status = "New";
      }
      if (item.status == STATUS_IN_PROGRESS) {
        item.status = "In Progress";
      }
      if (item.status == STATUS_PROCESSED) {
        item.status = "Processed";
      }
      if (item.status == STATUS_REJECTED) {
        item.status = "Rejected";
      }
      if (item.status == STATUS_APPROVED) {
        item.status = "Approved";
      }
      indiviBussData.push(item);
    }
  });
  let rating = indiviBussData[0]?.rating;
  useEffect(() => {
    if (indivLoanID != "") {
      axios
        .post(
          base_url +
            "investor-requests/get_investor_opportunity_single_business",
          {
            business_id: indiviBussData[0]?.business_id,
          }
        )
        .then((res) => {
          if (res.data.data !== "") {
            setBusinessData(res.data.data);
            setLoanHistory(res.data.data.loan_history);
            setLoanHistoryFilter(res.data.data.loan_history);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [indivLoanID]);
const [disable, setDisable] = useState(false)




const confirmInvestment = async () => {
    let obj = {
      business_id: indiviBussData[0]?.business_id,
      investor_id: investorMaster.investor_id,
      loan_id: indiviBussData[0]?.loan_id,
      investor_request_id: indiviBussData[0]?.investor_request_id,
      created_by: Cookies.get("investor_user_name"),
    };
    setDisable(true)
    axios
      .post(base_url + "investor-interests/save_investor_interests", obj)
      .then((res) => {
        if (res.status == 200) {
          toast.success("Success", {
            toastId: 14,
          });
          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  let splitdata;
  let aboutdata = businessData.about;
  if (aboutdata != undefined) {
    splitdata = aboutdata.split(". ");
  }

  let loanhistorydata = loanhistory;
  let loan_history_array = [];
  loanhistorydata?.map(each_history_record => {
    //NEW LOAN REQUEST LIST
    if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Business requested loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if((!each_history_record.is_investor_interested) && (!each_history_record.is_admin_sent_terms_to_business)){
    if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Admin filled the profit percentage and sent to investors";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
  }
    if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Admin rejected the new loan request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.is_investor_interested===1 && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Investor has shown interest on this loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.is_admin_sent_terms_to_business===1 && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Admin sent loan terms and awaiting for business response";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }

    if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Business agreed the new loan request terms";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }

    if (each_history_record.status == STATUS_PROCESSED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = (
        <div className='style_loan_txt'>
          Admin paid the requested loan amount <span style={{color:"black",marginTop:"2px" }} className="ps-1 pe-1 fw-bold">{each_history_record.paid_currency +" "+ Number(each_history_record.paid_amount).toLocaleString() }</span> to business on <span style={{color:"black",marginTop:"2px"}} className="ps-1 pe-1 fw-bold">{ moment(each_history_record.paid_date).format('DD MMM YYYY')}</span>
        </div>
      );
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == LOAN_REPAYMENT_BY_BUSINESS && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = 

      <div className=''>
  Business repaid for the month of <span style={{color:"black" }} className=" fw-bold">{moment(each_history_record.tenure_date).format('MMMM')}</span>, loan tenure amount <span style={{color:"black"}} className="fw-bold">{ each_history_record.paid_currency +" "+ Number(each_history_record.paid_amount).toLocaleString()}</span> to admin on <span style={{color:"black"}} className="fw-bold">{moment(each_history_record.paid_date).format('DD MMM YYYY')}</span>
            </div>
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }


    if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
      let message = "Business requested to extend loan tenure";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
      let message = "Admin approved extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }


    if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
      let message = "Admin rejected the extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }


    if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
      let message = "Business requested for pre closure of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
      let message = "Admin approved pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
      let message = "Admin rejected pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Business requested for partial pre-payment of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin approved partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin rejected partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (each_history_record.status == STATUS_CLOSED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Business repaid the loan successfully"
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
  }) 
const expectedReturn = indiviBussData[0]?.expected_return;
const currency = indiviBussData[0]?.admin_request_loan_currency === LOAN_CURRENCY_TYPE_USD ? "$" : "BHD";
const formattedAmount = `${currency} ${Number(expectedReturn).toLocaleString()}`;

const [sortOrder, setSortOrder] = useState({ column: null, direction: null });

const [loanHistoryFilter, setLoanHistoryFilter]= useState([])
const headers = [
  { title: "Principal", field: "admin_request_loan_amount" },
  { title: "Tenure", field: "admin_request_loan_tenure" },
  { title: "Amt Repaid", field: "principal_repaid" },
  { title: "Extend Tenure", field: "is_extend_tenure_raised" },
  { title: "Preclosure", field: "is_preclosure_raised" },
];
const handleSort = (column) => {
  let direction = "asc";
  if (sortOrder.column === column && sortOrder.direction === "asc") {
    direction = "desc";
  }
  setSortOrder({ column, direction });
  const sortedData = [...loanhistorydata].sort((a, b) => {
    const columnA = a[column];
    const columnB = b[column];
    if (typeof columnA === "string" && typeof columnB === "string") {
      return direction === "asc"
        ? columnA.localeCompare(columnB)
        : columnB.localeCompare(columnA);
    } else if (typeof columnA === "number" && typeof columnB === "number") {
      return direction === "asc" ? columnA - columnB : columnB - columnA;
    } else {
      return 0;
    }
  });
  setLoanHistoryFilter(sortedData);
};

  return (
    <div>
      <div className="indiv_bus_tilte">
        <img
          width={12}
          src="./images/left_arrow.svg"
          alt=""
          onClick={props.habd}
        />
        <h1 className="" onClick={props.habd}>
          {businessData.business_name}
        </h1>
      </div>
      <div className="row justify-content-between pe-3 ps-3 gap-5">
        <Card className="col indiv_bus_card_styl">
          <div className="">
            <h4
              className={` ${
                rating === RATING_A
                  ? "rate_A"
                  : rating === RATING_B
                  ? "rate_B"
                  : rating === RATING_C
                  ? "rate_C"
                  : "rate_D"
              }`}
            >
              {rating === RATING_A
                ? "A"
                : rating === RATING_B
                ? "B"
                : rating === RATING_C
                ? "C"
                : rating === RATING_D
                ? "D"
                : ""}
            </h4>
            <Card.Img
              variant="top"
              src={indiviBussData[0]?.business_image_url}
              className="indiv_busns_top_img"
            />
            <Card.Body className="">
              <Card.Text>
                <div className="row bg-white ">
                  <div className="col">
                    <ul
                      className="nav nav-tabs d-flex"
                      id="myTab"
                      role="tablist"
                    >
                      <li className="nav-item-indiv-busns" role="presentation">
                        <button
                          className="nav-link-inv active p-1"
                          id="About-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#About-tab-pane"
                          type="button"
                          role="tab"
                          aria-controls="About-tab-pane"
                          aria-selected="true"
                        >
                          <h3>About</h3>
                        </button>
                      </li>
                      <li className="nav-item-indiv-busns" role="presentation">
                        <button
                          className="nav-link-inv p-1"
                          id="CurrentLoanDetails-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#CurrentLoanDetails-tab-pane"
                          type="button"
                          role="tab"
                          aria-controls="CurrentLoanDetails-tab-pane"
                          aria-selected="false"
                        >
                          <h3>Current Loan Details</h3>
                        </button>
                      </li>
                      <li className="nav-item-indiv-busns" role="presentation">
                        <button
                          className="nav-link-inv p-1"
                          id="loanhistory-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#loanhistory-tab-pane"
                          type="button"
                          role="tab"
                          aria-controls="loanhistory-tab-pane"
                          aria-selected="false"
                        >
                          <h3>Loan History</h3>
                        </button>
                      </li>
                      </ul>
                  </div>
                  <div className="tab-content "  id="myTabContent">
                    <div
                      className="tab-pane fade show active line_height_about_inv"
                      id="About-tab-pane"
                      role="tabpanel"
                      aria-labelledby="About-tab"
                      tabIndex="0"
                    >
                      {getAboutBusinessHtml(indiviBussData[0]) ? (
                        <div
                          className="about-business-content investor-about-content"
                          dangerouslySetInnerHTML={{ __html: getAboutBusinessHtml(indiviBussData[0]) }}
                        />
                      ) : (
                        <p className="paragraph">
                          {indiviBussData[0]?.about_business}
                        </p>
                      )}
                    </div>
                    <div
                      className="tab-pane fade loanhistory_tab loanhistory_tab_styl"
                      id="loanhistory-tab-pane"
                      role="tabpanel"
                      aria-labelledby="loanhistory-tab"
                      tabIndex="0"
                    >
                    

              <div className="invOpp_loaHistory_masterDiv">
                <div className="invOpp_loaHistory_mainDiv">
                  <Table striped  hover className="">
                          <thead >
                            <tr>
                              {headers.map((column) => (
                                <th
                                  key={column.field}
                                  onClick={() => handleSort(column.field)}
                                >
                                  {column.title}
                                  &#9662;
                                </th>
                              ))}
                            </tr>
                          </thead>
                            {loanHistoryFilter.length>0?(
                              <tbody>
                              {loanHistoryFilter?.map((data, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    {loading ? (
                                      <Skeleton width={100} height={15} />
                                    ) : data.admin_request_loan_currency ===
                                      LOAN_CURRENCY_TYPE_BHD ? (
                                      "BHD " +
                                      Number(data.admin_request_loan_amount).toLocaleString()
                                    ) : (
                                      "$ "
                                      +
                                      Number(data.admin_request_loan_amount).toLocaleString())
                                    }
                                  </td>
                                  <td>
                                    {loading ? (
                                      <Skeleton width={100} height={15} />
                                    ) : (
                                      data.admin_request_loan_tenure ===1 ? data.admin_request_loan_tenure + " Month" : data.admin_request_loan_tenure >1 ? data.admin_request_loan_tenure+" Months":'-'
                                    )}
                                  </td>
                                  <td>
                                    {loading ? (
                                      <Skeleton width={100} height={15} />
                                    ) : data.admin_request_loan_currency ===
                                      LOAN_CURRENCY_TYPE_BHD ? (
                                      "BHD " +
                                      Number(data.principal_repaid).toLocaleString()
                                    ) : (
                                      "$ " +
                                      Number(data.principal_repaid).toLocaleString())
                                    }
                                  </td>
                                  <td>
                                    {loading ? (
                                      <Skeleton width={100} height={15} />
                                    ) : (
                                      data.is_extend_tenure_raised === 1 ?  "Yes" :'No'
                                    )}
                                  </td>
                                  <td>
                                    {loading ? (
                                      <Skeleton width={100} height={15} />
                                    ) : (
                                      data.is_preclosure_raised === 1 ?  "Yes" :'No'
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                            </tbody>
                          ):
                            <div className="message-box ">
                              No Loan History
                            </div>}
                        </Table>
                </div>
              </div>




                    </div>

                    <div
                      className="tab-pane fade CurrentLoanDetails_tab"
                      id="CurrentLoanDetails-tab-pane"
                      role="tabpanel"
                      aria-labelledby="CurrentLoanDetails-tab"
                      tabIndex="0"
                    >
                      {" "}
                      <div className="row mt-3">
                        <div className="col-lg-12 ">
                          <div className="row mb-3">
                            <div className="col-3">
                              <p className="text_st">Status</p>
                              <div className="bolder_text ">
                                {indiviBussData[0]?.status === undefined || indiviBussData[0]?.status === '' ? '-' : indiviBussData[0]?.status}
                              </div>
                            </div>

                            <div className="col-3">
                              <p className="text_st">Interest Frequency</p>
                              <div className="bolder_text">
                                {indiviBussData[0]?.interest_frequency === undefined || indiviBussData[0]?.interest_frequency === ''? '-' : indiviBussData[0]?.interest_frequency}
                              </div>
                            </div>
                            <div className="col">
                              <p className="text_st">Principal Frequency</p>
                              <div className="bolder_text">
                                {indiviBussData[0]?.principal_frequency}{" "}
                              </div>
                            </div>
                          </div>
                          <div className="row mt-4 mb-3">
                            <div className="col-3">
                              <p className="text_st">Amount Requested</p>
                              <span className="bolder_text">
                                {indiviBussData[0]
                                  ?.admin_request_loan_currency ==
                                LOAN_CURRENCY_TYPE_USD
                                  ? "$ " + Number(indiviBussData[0]?.admin_request_loan_amount).toLocaleString()
                                  : indiviBussData[0]
                                      ?.admin_request_loan_currency ==
                                    LOAN_CURRENCY_TYPE_BHD
                                  ? LOAN_CURRENCY_TYPE_BHD +
                                    " " +
                                    Number(indiviBussData[0]?.admin_request_loan_amount).toLocaleString()
                                  : "-"}
                              </span>
                            </div>
                            <div className="col-3">
                              <p className="text_st">Loan Tenure</p>
                              <div className="bolder_text">
                                {indiviBussData[0]?.admin_request_loan_tenure === undefined || indiviBussData[0]?.admin_request_loan_tenure=== '' ? '-' :
                                indiviBussData[0]?.admin_request_loan_tenure === 1
                                  ? indiviBussData[0]?.admin_request_loan_tenure+ " Month"
                                  : indiviBussData[0]?.admin_request_loan_tenure+ " Months" }
                              </div>
                            </div>
                            <div className="col-3">
                              <p className="text_st">Return Percentage</p>
                              <div className="bolder_text">
                                {indiviBussData[0]?.investor_roi}% per month
                              </div>
                            </div>
                          </div>

                          <div className="row mb-3 mt-4 ">
                            <div className="col">
                              <p className="text_st"> Admin Comments</p>
                              <div className="bolder_text mt-1 current_L_Details">
                                {" "}
                                {indiviBussData[0]?.admin_notes === undefined || indiviBussData[0]?.admin_notes==='' ? '-' : indiviBussData[0]?.admin_notes}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Text>
            </Card.Body>
          </div>
        </Card>

      
        <Card className="col-md-4 col InvOpp_right_tab">
        <div style={{ position: 'relative' }}>
    <Card.Img variant="top" src="./images/inv_right_top_bnr.svg" />
    <Card.Title className="inv_opp_card_title">Investment Opportunity</Card.Title>
  </div>
  <Card.Body className="InvOpp_right_tab_bdy">
              <div className="d-flex justify-content-between mb-3 row">
                <div className="blue_tab_single_inv   px-lg-2 p-xxl-2 col me-2 mb-2">
                  <p>Investment Amount</p>
                  <p className="">
                    {indiviBussData[0]?.admin_request_loan_currency ===
                    LOAN_CURRENCY_TYPE_USD
                      ? "$ "
                      : LOAN_CURRENCY_TYPE_BHD + " "}
                    {Number(indiviBussData[0]?.admin_request_loan_amount).toLocaleString()}
                  </p>
                </div>

                <div className="sesame_tab_single_inv  px-lg-2 p-xxl-2 col mb-2">
                  <p>Tenure & Profit Rate</p>
                  <p className="">
                    {indiviBussData[0]?.admin_request_loan_tenure === 1
                      ? indiviBussData[0]?.admin_request_loan_tenure + " Month "
                      : indiviBussData[0]?.admin_request_loan_tenure +
                        " Months"}
                    {" - "}
                    {indiviBussData[0]?.investor_roi}% per month
                  </p>
                </div>
              </div>
              <div className="indiv_bus_exp_ret">
                <p className="text-black fs-6 mb-1"> Total Expected Return</p>
                <b>
                {formattedAmount}
                </b>
              </div>
              <hr />

<div className="row">
  <div className="col">
  <div>
                {" "}
                Interest Frequency{" "}
              </div>
              <div  className="mb-3">
                {" "}
                Principal Frequency{" "}
              </div>

  </div>
  <div className="col">
  <div className="ps-2 sesam_c"> : {indiviBussData[0]?.interest_frequency}
                </div>
                <div className="ps-2 sesam_c"> : {indiviBussData[0]?.principal_frequency === undefined || indiviBussData[0]?.principal_frequency === '' ? '-' : indiviBussData[0]?.principal_frequency}
                </div>

  </div>
</div>





              
              
              
              <span>Schedule Of Payments</span>
              <hr />
              <div className="inv_opp_table">
                <table responsive="sm" className="inv_opp_indi_right_tab">
                  <thead>
                    <tr className="justify-content-between">
                      <th className="style_table_inv_lite1">
                        <p className="pe-3">Repayment Amount</p>
                      </th>
                      <th className="style_table_inv_lite ms-3">
                        <p className="ps-4">Scheduled Month</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="inv_opp_single_table">
                    {indiviBussData[0]?.amount.map((data) => {
                      return (
                        <tr className="">
                          <td className="style_table_inv1">
                            <div className="text-right pe-3">
                              {indiviBussData[0]?.admin_request_loan_currency}{" "}
                              {Number(data.investor_profit).toLocaleString()}
                            </div>
                          </td>
                          <td className="style_table_inv">
                            <div className="text-left ms-4">
                              {moment(data.tenure_date).format("MMM YYYY")}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>           
              </div>
        
            </Card.Body>
        <Card.Footer className="inv_opp_footer_btn">
          <small className="text-muted">
          <div className="inv_opp_ind_right_tab_btn">
                <button className="btn blue_btn " disabled={disable} onClick={confirmInvestment}>
                    Confirm Investment
                  </button>
              </div>
          </small>
        </Card.Footer>
      </Card>


      </div>
    </div>
  );
};
